/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF, useAnimations, useTexture } from "@react-three/drei";
import model from "./Shopping_V7.glb";
import espaco from "./materials/Espaco_Diffuse.jpg";

export default function Model({ ...props }) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(model);
  const { actions } = useAnimations(animations, group);
  const espacoTexture = useTexture(espaco);

  Object.entries(materials).forEach(([key, value]) => {
    value.envMapIntensity = props.envMapIntensity;
  });
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="ForroBaixo"
          geometry={nodes.ForroBaixo.geometry}
          material={materials.ForroBaixo}
          position={[0, 4, 0]}
        />
        <mesh
          name="Pilares"
          geometry={nodes.Pilares.geometry}
          material={materials.Pilares}
          position={[0.03, 1.19, 0.06]}
        />
        <mesh
          name="Balcao"
          geometry={nodes.Balcao.geometry}
          material={materials.Balcao}
          position={[0, 0.55, -5.58]}
        />
        <mesh
          name="Espaco"
          geometry={nodes.Espaco.geometry}
          material={materials.Espaco}
          material-map={espacoTexture}
          material-map-flipY={false}
          position={[0, 4.5, 0]}
        />
        <mesh
          name="Piso"
          geometry={nodes.Piso.geometry}
          material={materials.Piso}
        />
        <mesh
          name="Arandelas"
          geometry={nodes.Arandelas.geometry}
          material={materials.Arandelas}
          position={[-0.72, 2.34, -0.25]}
          rotation={[0, -Math.PI / 2, 0]}
        />
        <mesh
          name="Cadeira001"
          geometry={nodes.Cadeira001.geometry}
          material={materials.Cadeiras01}
          position={[5.44, 0.52, -0.44]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira002"
          geometry={nodes.Cadeira002.geometry}
          material={materials.Cadeiras02}
          position={[5.44, 0.52, -2.9]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira003"
          geometry={nodes.Cadeira003.geometry}
          material={materials.Cadeiras03}
          position={[3.09, 0.52, 1.98]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira004"
          geometry={nodes.Cadeira004.geometry}
          material={materials.Cadeiras04}
          position={[3.09, 0.52, -0.44]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira005"
          geometry={nodes.Cadeira005.geometry}
          material={materials.Cadeiras05}
          position={[3.09, 0.52, -2.9]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira006"
          geometry={nodes.Cadeira006.geometry}
          material={materials.Cadeiras06}
          position={[0.51, 0.52, 1.98]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira007"
          geometry={nodes.Cadeira007.geometry}
          material={materials.Cadeiras07}
          position={[0.51, 0.52, -0.44]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira008"
          geometry={nodes.Cadeira008.geometry}
          material={materials.Cadeiras08}
          position={[0.51, 0.52, -2.9]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira009"
          geometry={nodes.Cadeira009.geometry}
          material={materials.Cadeiras09}
          position={[-2.24, 0.52, 1.98]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira010"
          geometry={nodes.Cadeira010.geometry}
          material={materials.Cadeiras10}
          position={[-2.24, 0.52, -0.44]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira011"
          geometry={nodes.Cadeira011.geometry}
          material={materials.Cadeiras11}
          position={[-2.24, 0.52, -2.9]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira012"
          geometry={nodes.Cadeira012.geometry}
          material={materials.Cadeiras12}
          position={[-4.89, 0.52, -0.44]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira013"
          geometry={nodes.Cadeira013.geometry}
          material={materials.Cadeiras13}
          position={[-4.89, 0.52, -2.9]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira014"
          geometry={nodes.Cadeira014.geometry}
          material={materials.Cadeiras14}
          position={[-7.28, 0.52, -0.44]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira015"
          geometry={nodes.Cadeira015.geometry}
          material={materials.Cadeiras15}
          position={[-7.28, 0.52, -2.9]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira016"
          geometry={nodes.Cadeira016.geometry}
          material={materials.Cadeiras16}
          position={[-7.28, 0.52, -8.58]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira017"
          geometry={nodes.Cadeira017.geometry}
          material={materials.Cadeiras17}
          position={[-7.28, 0.52, -11.33]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira018"
          geometry={nodes.Cadeira018.geometry}
          material={materials.Cadeiras18}
          position={[-4.87, 0.52, -11.38]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira019"
          geometry={nodes.Cadeira019.geometry}
          material={materials.Cadeiras19}
          position={[-4.87, 0.52, -8.57]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira020"
          geometry={nodes.Cadeira020.geometry}
          material={materials.Cadeiras20}
          position={[5.5, 0.52, -11.38]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Cadeira021"
          geometry={nodes.Cadeira021.geometry}
          material={materials.Cadeiras21}
          position={[5.5, 0.52, -8.57]}
          rotation={[Math.PI / 2, 0, Math.PI / 4]}
        />
        <mesh
          name="Luminarias"
          geometry={nodes.Luminarias.geometry}
          material={materials.Luminarias}
          position={[-0.2, 4.05, -2.34]}
        />
        <mesh
          name="PaineisWays"
          geometry={nodes.PaineisWays.geometry}
          material={materials.PaineisWays}
          position={[-4.55, 0.6, -4.14]}
        />
        <group name="Mesa001" position={[4.95, 0.66, 0.07]}>
          <mesh
            name="Cylinder002"
            geometry={nodes.Cylinder002.geometry}
            material={nodes.Cylinder002.material}
          />
          <mesh
            name="Cylinder002_1"
            geometry={nodes.Cylinder002_1.geometry}
            material={nodes.Cylinder002_1.material}
          />
        </group>
        <group name="Mesa002" position={[4.95, 0.66, -2.39]}>
          <mesh
            name="Cylinder003"
            geometry={nodes.Cylinder003.geometry}
            material={nodes.Cylinder003.material}
          />
          <mesh
            name="Cylinder003_1"
            geometry={nodes.Cylinder003_1.geometry}
            material={nodes.Cylinder003_1.material}
          />
        </group>
        <group name="Mesa003" position={[2.6, 0.66, 2.5]}>
          <mesh
            name="Cylinder004"
            geometry={nodes.Cylinder004.geometry}
            material={nodes.Cylinder004.material}
          />
          <mesh
            name="Cylinder004_1"
            geometry={nodes.Cylinder004_1.geometry}
            material={nodes.Cylinder004_1.material}
          />
        </group>
        <group name="Mesa004" position={[2.6, 0.66, 0.07]}>
          <mesh
            name="Cylinder005"
            geometry={nodes.Cylinder005.geometry}
            material={nodes.Cylinder005.material}
          />
          <mesh
            name="Cylinder005_1"
            geometry={nodes.Cylinder005_1.geometry}
            material={nodes.Cylinder005_1.material}
          />
        </group>
        <group name="Mesa005" position={[2.6, 0.66, -2.39]}>
          <mesh
            name="Cylinder006"
            geometry={nodes.Cylinder006.geometry}
            material={nodes.Cylinder006.material}
          />
          <mesh
            name="Cylinder006_1"
            geometry={nodes.Cylinder006_1.geometry}
            material={nodes.Cylinder006_1.material}
          />
        </group>
        <group name="Mesa006" position={[0.02, 0.66, 2.5]}>
          <mesh
            name="Cylinder007"
            geometry={nodes.Cylinder007.geometry}
            material={nodes.Cylinder007.material}
          />
          <mesh
            name="Cylinder007_1"
            geometry={nodes.Cylinder007_1.geometry}
            material={nodes.Cylinder007_1.material}
          />
        </group>
        <group name="Mesa007" position={[0.02, 0.66, 0.07]}>
          <mesh
            name="Cylinder008"
            geometry={nodes.Cylinder008.geometry}
            material={nodes.Cylinder008.material}
          />
          <mesh
            name="Cylinder008_1"
            geometry={nodes.Cylinder008_1.geometry}
            material={nodes.Cylinder008_1.material}
          />
        </group>
        <group name="Mesa008" position={[0.02, 0.66, -2.39]}>
          <mesh
            name="Cylinder009"
            geometry={nodes.Cylinder009.geometry}
            material={nodes.Cylinder009.material}
          />
          <mesh
            name="Cylinder009_1"
            geometry={nodes.Cylinder009_1.geometry}
            material={nodes.Cylinder009_1.material}
          />
        </group>
        <group name="Mesa009" position={[-2.73, 0.66, 2.5]}>
          <mesh
            name="Cylinder010"
            geometry={nodes.Cylinder010.geometry}
            material={nodes.Cylinder010.material}
          />
          <mesh
            name="Cylinder010_1"
            geometry={nodes.Cylinder010_1.geometry}
            material={nodes.Cylinder010_1.material}
          />
        </group>
        <group name="Mesa010" position={[-2.73, 0.66, 0.07]}>
          <mesh
            name="Cylinder011"
            geometry={nodes.Cylinder011.geometry}
            material={nodes.Cylinder011.material}
          />
          <mesh
            name="Cylinder011_1"
            geometry={nodes.Cylinder011_1.geometry}
            material={nodes.Cylinder011_1.material}
          />
        </group>
        <group name="Mesa011" position={[-2.73, 0.66, -2.39]}>
          <mesh
            name="Cylinder012"
            geometry={nodes.Cylinder012.geometry}
            material={nodes.Cylinder012.material}
          />
          <mesh
            name="Cylinder012_1"
            geometry={nodes.Cylinder012_1.geometry}
            material={nodes.Cylinder012_1.material}
          />
        </group>
        <group name="Mesa012" position={[-5.37, 0.66, 0.07]}>
          <mesh
            name="Cylinder014"
            geometry={nodes.Cylinder014.geometry}
            material={nodes.Cylinder014.material}
          />
          <mesh
            name="Cylinder014_1"
            geometry={nodes.Cylinder014_1.geometry}
            material={nodes.Cylinder014_1.material}
          />
        </group>
        <group name="Mesa013" position={[-5.37, 0.66, -2.39]}>
          <mesh
            name="Cylinder015"
            geometry={nodes.Cylinder015.geometry}
            material={nodes.Cylinder015.material}
          />
          <mesh
            name="Cylinder015_1"
            geometry={nodes.Cylinder015_1.geometry}
            material={nodes.Cylinder015_1.material}
          />
        </group>
        <group name="Mesa014" position={[-7.77, 0.66, 0.07]}>
          <mesh
            name="Cylinder017"
            geometry={nodes.Cylinder017.geometry}
            material={nodes.Cylinder017.material}
          />
          <mesh
            name="Cylinder017_1"
            geometry={nodes.Cylinder017_1.geometry}
            material={nodes.Cylinder017_1.material}
          />
        </group>
        <group name="Mesa015" position={[-7.77, 0.66, -2.39]}>
          <mesh
            name="Cylinder018"
            geometry={nodes.Cylinder018.geometry}
            material={nodes.Cylinder018.material}
          />
          <mesh
            name="Cylinder018_1"
            geometry={nodes.Cylinder018_1.geometry}
            material={nodes.Cylinder018_1.material}
          />
        </group>
        <group name="Mesa016" position={[-7.77, 0.66, -8.07]}>
          <mesh
            name="Cylinder019"
            geometry={nodes.Cylinder019.geometry}
            material={nodes.Cylinder019.material}
          />
          <mesh
            name="Cylinder019_1"
            geometry={nodes.Cylinder019_1.geometry}
            material={nodes.Cylinder019_1.material}
          />
        </group>
        <group name="Mesa017" position={[-7.77, 0.66, -10.81]}>
          <mesh
            name="Cylinder020"
            geometry={nodes.Cylinder020.geometry}
            material={nodes.Cylinder020.material}
          />
          <mesh
            name="Cylinder020_1"
            geometry={nodes.Cylinder020_1.geometry}
            material={nodes.Cylinder020_1.material}
          />
        </group>
        <group name="Mesa018" position={[-5.36, 0.66, -10.86]}>
          <mesh
            name="Cylinder021"
            geometry={nodes.Cylinder021.geometry}
            material={nodes.Cylinder021.material}
          />
          <mesh
            name="Cylinder021_1"
            geometry={nodes.Cylinder021_1.geometry}
            material={nodes.Cylinder021_1.material}
          />
        </group>
        <group name="Mesa019" position={[-5.36, 0.66, -8.06]}>
          <mesh
            name="Cylinder022"
            geometry={nodes.Cylinder022.geometry}
            material={nodes.Cylinder022.material}
          />
          <mesh
            name="Cylinder022_1"
            geometry={nodes.Cylinder022_1.geometry}
            material={nodes.Cylinder022_1.material}
          />
        </group>
        <group name="Mesa020" position={[5.01, 0.66, -10.86]}>
          <mesh
            name="Cylinder025"
            geometry={nodes.Cylinder025.geometry}
            material={nodes.Cylinder025.material}
          />
          <mesh
            name="Cylinder025_1"
            geometry={nodes.Cylinder025_1.geometry}
            material={nodes.Cylinder025_1.material}
          />
        </group>
        <group name="Mesa021" position={[5.01, 0.66, -8.06]}>
          <mesh
            name="Cylinder026"
            geometry={nodes.Cylinder026.geometry}
            material={nodes.Cylinder026.material}
          />
          <mesh
            name="Cylinder026_1"
            geometry={nodes.Cylinder026_1.geometry}
            material={nodes.Cylinder026_1.material}
          />
        </group>
      </group>
    </group>
  );
}

useGLTF.preload(model);
